import { AuthenticateWithRedirectCallback } from "@clerk/react";

/**
 * OAuth / social SSO return path (Google, X, GitHub, …).
 * Must be a real path route — not hash — so IdP + Clerk can complete the handshake.
 */
export function SsoCallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-og-ink text-zinc-400">
      <div className="flex flex-col items-center gap-3 px-4 text-center">
        <img
          src="/og-logo.png"
          alt=""
          className="h-12 w-12 animate-pulse rounded-2xl shadow-lg shadow-orange-500/30"
          width={48}
          height={48}
        />
        <p className="text-sm">Finishing sign-in…</p>
        {/* Fallback only — do not force, so OAuth keeps SignIn forceRedirectUrl (e.g. ?upgrade=team) */}
        <AuthenticateWithRedirectCallback
          signInFallbackRedirectUrl="/"
          signUpFallbackRedirectUrl="/"
        />
      </div>
    </div>
  );
}
